module.exports = {
  "version": "0.26.1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/data.js
// module id = 633
// module chunks = 29